import PopoverAntibodySpecification from "./PopoverAntibodySpecification";
import ClickableList from "./ClickableList";
import A from './ActionCreators';
import usePresentSelector from './usePresentSelector';
import { isDeleteObjectKey } from './EventUtils';
import SciugoInput from './SciugoInput';

import useComponentDrag from './useComponentDrag';

import G from './Getters';
import { add, minus } from './Geometry';
import {useEffect,useState,useRef} from 'react';
import { useDispatch } from 'react-redux';



import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import { shiftLineSegement } from './Geometry';

import { HEIGHT_GROUP_LABEL_INPUT } from './UIConstants';





export default function SimplePopover({
  w,
  onMouseEnter,
  onMouseLeave,
  setFocusedAnnotationId,
  focusedAnnotation,
  isFocusedAnnotation,
  annotation,
  notifyAnnotationPropertyChange,
  temporaryAnnotationProperties,

  setHoveredHeight,
  handleClose,

  anchorPosition,
  setAnchorPosition,

  onAnnotationDelete,

}){

  let popoverRef = useRef();

  let ls = temporaryAnnotationProperties.ls || focusedAnnotation.ls;

  let alreadyFocusedOnLoad = useRef(false);
  let __custom = "__custom";
  const [mouseDown,setMouseDown] = useState(null);
  let dispatch = useDispatch();

  const open = Boolean(anchorPosition);
  const id = open ? "simple-popover" : undefined;

  let fontSize = 10;

  let customHeight = Number(temporaryAnnotationProperties.height * w || focusedAnnotation.height * w || 30).toFixed(0);

  let targetName;
  if( typeof(temporaryAnnotationProperties.label) !== 'string' ){
    targetName = focusedAnnotation.label
  }else{
    targetName = temporaryAnnotationProperties.label;
  };

  function onMouseMoveAndDown(e){

    if( mouseDown ){

      let popoverPositionToSet = minus([e.clientX,e.clientY],mouseDown);
      let xx = {
        left:popoverPositionToSet[0],
        top:popoverPositionToSet[1]
      }
      //console.log(JSON.stringify(xx));
      setAnchorPosition(xx);
    }

  }

  let onMouseDown = (e) => {
    if( popoverRef && popoverRef.current ){
      let popoverBounds = popoverRef.current.getBoundingClientRect();
      let popoverPosition =[
        e.clientX-popoverBounds.left,
        e.clientY-popoverBounds.top
      ];
      setMouseDown(popoverPosition);
    }
  }


  let onComponentMouseDown = useComponentDrag({
    ref:popoverRef,
    onMouseMoveAndDown,
    onMouseUp:(() => { setMouseDown(false); }),
    onMouseDown
  })

  let shaddowStyle = {
    boxShadow:'0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
  }

  let noTopShaddow = {
    //boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1), 0px 0px 6px rgba(0, 0, 0, 0.1)',
    //boxShadow:'0px 8px 10px rgba(0,0,0,0.14), 0px 0px 14px rgba(0,0,0,0.12)',
  }

  const POPOVER_WIDTH = 165;

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ 
        zIndex:50,
        position:'fixed',
        ...anchorPosition,
        width:POPOVER_WIDTH,
      }}
      anchorReference="anchorPosition"
      id={id}
      open={open}
      anchorPosition={anchorPosition}
      onClose={handleClose}
    >

      
      {false && <div style={{
          position:'absolute',
          width:100,
          height:100,
          ...noTopShaddow,
          background:'#eee',
          top:'98%',
        }}>
      <ClickableList onEvent={event => {

      }}/>
    </div>}



      <div onClick={e => {
        e.stopPropagation();

        dispatch(A.setAnnotationProperties({
          _id:focusedAnnotation._id, 
          ...temporaryAnnotationProperties,

        }))
        handleClose();

      }}
        class="hoverable sg-row v-center h-center" style={{
          position:'absolute', 
          width:15, height:15, 
          top:-7.5,
          right:-7.5,
          borderRadius:15,
          cursor:'pointer',
          lineHeight:1,
          fontSize:13,
          fontWeight:'bold',
          textAlign:'center',
          background:'#eeeeee',
          color:'black',
          zIndex:3,
        }}>
        ×
      </div>

      <div 
        style={{ 
          borderRadius:4,    
          ...shaddowStyle,
          background:'white',
        }}
        onMouseLeave={() => setHoveredHeight(null)} 
        className={null}>

        {false && <>
        <div class="bgm">
        <i> The problem is... how do we know which application we're labelling for?</i>
          <div>I think in microscopy we have something...</div>
          <div>But by default, it's western blot.</div>
      </div>
        </>}


        <div 
          ref={popoverRef}
          onMouseDown={onComponentMouseDown}

          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={{
            width:'100%',height:10,
            cursor:(mouseDown?'grabbing':'grab'), 
            zIndex:2,
            borderRadius:'2px 2px 0px 0px',
            background:'rgba(222,225,231)',
            //position:'absolute',
            borderBottom:'1px solid rgba(190,190,190)'
          }}/>




        <SciugoInput 
          input={"crop-label-field"}
          inputRef={el => {
            if(!targetName && el && alreadyFocusedOnLoad.current === false){
              alreadyFocusedOnLoad.current = true;
              el.focus()
            }
          }}

          onKeyUp={e => {


            if(e.key === 'Enter' && targetName.trim() !== ''){


              dispatch(A.setAnnotationProperties({
                _id:focusedAnnotation._id, 
                ...temporaryAnnotationProperties,
                label:e.target.value
              }))
              handleClose();
            }
          }}

          onKeyDown={e => {

            //console.error("Typing something! " + e.key);

            if( isDeleteObjectKey(e) && targetName === '' ){
              onAnnotationDelete(focusedAnnotation._id);
            }
          }}


          value={targetName}
          onBlur={e => {
            dispatch(A.setAnnotationProperties({
              _id:focusedAnnotation._id, 
              ...temporaryAnnotationProperties,
              label:e.target.value,

            }))
          }}
          onChange={e => {
            notifyAnnotationPropertyChange({label:e.target.value})
          }}
          onClick={e => e.stopPropagation()}
          style={{
            margin:5,fontSize:12, 
            width:'calc(100% - 10px)',
            opacity:0.95,
            
          }} 
          placeholder={"Protein name"}/>




        {true && <PopoverAntibodySpecification key={focusedAnnotation?._id} focusedAnnotation={focusedAnnotation} />}

        {false && <div class="sg-row" style={{padding:7, background:'#eee',borderBottomLeftRadius:3, borderBottomRightRadius:3}}>
          
          <div>Antibody: </div>

          <div class="flex-expand"/>
          <input 
            style={{width:90, marginLeft:10, fontSize}} 
            //type="number" 
            //value={customHeight} 
            onChange={e =>{ notifyAnnotationPropertyChange({
              heightGroupId:__custom,
              height:Number(e.target.value)/w
            })
            }}
          />
        </div>}

        


        {true && <div class="sg-row" style={{padding:7, background:'#eee',borderBottomLeftRadius:3, borderBottomRightRadius:3}}>
          <div>Height: </div>

          <div class="flex-expand"/>
          <input 
            style={{width:40, marginLeft:10, fontSize}} type="number" value={customHeight} onChange={e =>{ notifyAnnotationPropertyChange({
              heightGroupId:__custom,
              height:Number(e.target.value)/w
            })
            }} />
        </div>}
      </div>
      <div>
      </div>
    </div>
  );
}

